export default __webpack_public_path__ + "static/media/HISTORY_GOVERNMENT.12df6018.svg";